export { default } from './HotLinks';